import stat from 'utils/stat';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import ShareToast from 'components/Followee/ShareToast';

import wxUtil from '../../utils/wx';
import JigsawBottom from './JigsawBottom';
import JigsawPortal from './JigsawPortal';
import PosterPortal from './PosterPortal';
import RootStore from '../../store/RootStore';
import { IOneGallery } from '../GalleryList/Common';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

export const MAX_JIGSAW_NUM = 16;

export const minNumberByType = (type: string) => {
  if (type == 'long') {
    return 2;
  }
  if (type == 'poster') {
    return 1;
  }

  return 1;
};

export const maxNumberByType = (type: string) => {
  if (type == 'long') {
    return 12;
  }
  if (type == 'poster') {
    return 1;
  }
  if (type == 'download') {
    return 50;
  }
  if (type == 'share' || type == 'imageshare') {
    return 50;
  }

  return 9;
};

interface IAllForJigsaw {
  rootStore?: RootStore;
  from?: any;
  avatar?: string;
}

const AllForJigsaw = function (props: IAllForJigsaw) {
  const { avatar = '' } = props;
  const { uiStore, relationStore, wxuserStore } =
    props.rootStore!;
  const activeGallery = activeGalleryInstance.get();
  const jigsaw = activeGallery ? activeGallery.jigsaw : { bottomShow: false, jigsawList: [] as IOneGallery[], type: '' };
  const setJigsaw = activeGallery ? activeGallery.setJigsaw : () => {};
  const { bottomShow, jigsawList } = jigsaw;

  const currentGalleryData = window.dataDetail
    ? window.dataDetail
    : window.gallery;
  const usePay = Number(currentGalleryData.is_pay_down) > 0;

  const [poster, setPoster] = useState([] as IOneGallery[]);
  const [long, setLong] = useState([] as IOneGallery[]);

  const [sharePerson, setSharePerson] = useState(0);

  const processEvent = (event: any) => {
    let { data } = event;

    setJigsaw({
      type: 'poster',
      bottomShow: true,
      jigsawList: data.ids,
      from: data.from || '',
    });
    setPoster(data.ids);
  };

  useEffect(() => {
    window.addEventListener('set-jigsaw-data', processEvent);

    return () => {
      window.removeEventListener('set-jigsaw-data', processEvent);
    };
  }, []);

  // console.log(bottomShow, 'bottomShow');
  const onCancel = () => {
    // 清空
    if (jigsaw && jigsaw.from && jigsaw.from == 'bigpic') {
      let changeEvent = new Event('CHANGE_BODY_SCROLL');
      changeEvent.data = false;
      window.dispatchEvent(changeEvent);
    }
    setJigsaw({ bottomShow: false, jigsawList: [] });
    setPoster([]);
  };

  const onConfirm = () => {
    const { length } = jigsawList;
    const { type } = jigsaw;
    if (length < minNumberByType(type)) {
      const minKey =
        type === 'download'
          ? 'min-download'
          : type == 'share'
          ? 'min-share'
          : 'min-jigsaw';
      uiStore.showAlert({
        content: intl.get(minKey, { num: minNumberByType(jigsaw.type) }),
      });
      return;
    } else if (length > maxNumberByType(type)) {
      const maxKey =
        type === 'download'
          ? 'MAX_DOWNLOAD_NUM'
          : type == 'share'
          ? 'MAX_SHARE_NUM'
          : 'MAX_JIGSAW_NUM';
      uiStore.showAlert({
        content: intl.get(maxKey, {
          num: maxNumberByType(jigsaw.type),
        }),
      });
      return;
    }

    // 此处需要嵌入是否需要付费的判断
    if (usePay) {
      // const currentGood = wxuserStore.currentPayGood[String(currentGalleryData.is_pay_down)];
      // 所选图片所在的相册/子相册，是否需要付费？如何判断呢
      // 暂停尝试，在勾选图片的时候，就去请求判断一下

      // 判断当前id是否在已付费列表里
      const notPayed = wxuserStore.getNotPayed(jigsawList.map((it) => it.id));
      // let notPayed = [id];
      if (notPayed && notPayed.length) {
        // 弹出付费
        // gallery_id: string | number, goods_id: string | number, link_id: string, imgids: number[]
        uiStore.showToast({ content: intl.get('ReadyToPay') });
        return wxuserStore.payToImage(
          currentGalleryData.id,
          Number(currentGalleryData.is_pay_down),
          window.pageDetail.link_id,
          notPayed
        );
      }
    }

    if (type == 'long') {
      setLong(jigsawList);
    }
    if (jigsaw.type == 'poster') {
      setPoster(jigsawList);
    }
    if (jigsaw.type == 'download') {
      // 直接调起小程序下载了，代码层无需处理
    }
    if (jigsaw.type == 'share') {
      setSharePerson(relationStore.person.id);
    }
  };

  if (bottomShow) {
    return (
      <>
        <JigsawBottom
          onCancel={onCancel}
          onConfirm={onConfirm}
          type={jigsaw.type}
          list={jigsawList}
        />
        {
          // 注意，PosterPortal里边会锁定滚动，所以不适合在不需要的场景下渲染出来
          poster?.length ? (
            <PosterPortal
              data={poster}
              onClose={() => {
                setPoster([]);
                onCancel();
              }}
            />
          ) : null
        }
        {sharePerson ? (
          <ShareToast
            hideSubTitle={true}
            getDefaultShare={() => {
              //  选取分享 => 这里的sharePerson是当前分享的人选取了一些照片进行分享
              const decodedAvatar = decodeURIComponent(avatar || '');
              const finalAvatar = decodedAvatar.startsWith('//')
                  ? decodedAvatar.replace('//', 'https://')
                  : decodedAvatar;
              return wxUtil.configImageShare(
                  jigsaw.jigsawList.map((it: IOneGallery) => it.id),
                  {
                    image: finalAvatar,
                  }
              );
            }}
            onClose={() => setSharePerson(0)}
            onLinkClick={() => {
              props.rootStore!.uiStore.showToast({
                content: intl.get('Copyed'),
              });
              setSharePerson(0);
              onCancel();
            }}
            onEditClick={(options?: any) => {
              wxUtil.configImageShare(
                jigsaw.jigsawList.map((it: IOneGallery) => it.id),
                options
              );
              wxUtil.showShareLimitTip(() => {
                setSharePerson(0);
                wxUtil.configPersonShare(relationStore.person.id);
                onCancel();

                if (options && options.title) {
                  stat.event('share_desc', {
                    title: options.title,
                    desc: options.desc,
                  });
                }
              });
            }}
          />
        ) : null}
        {long?.length ? (
          <JigsawPortal
            data={long}
            onClose={() => {
              setLong([]);
              onCancel();
            }}
          />
        ) : null}
      </>
    );
  }

  return null;
};

export default inject('rootStore')(observer(AllForJigsaw));
